import type { QueryClient } from '@tanstack/react-query';
import type { User } from '../types';
import type { ApiRequestConfig } from './api';
import { getPrivateQueryGeneration } from './queryPrivacy';
import { getStoredActiveTenantId } from './tenantStorage';

/** Keep hold, confirmation and cache writes owned by the same family context. */
export function captureFamilyRequest(queryClient: QueryClient, callerGuard?: () => void) {
  const generation = getPrivateQueryGeneration();
  const tenantId = getStoredActiveTenantId();
  const accountId = queryClient.getQueryData<User | null>(['auth', 'user'])?.id;
  const assertCurrent = () => {
    callerGuard?.();
    if (generation !== getPrivateQueryGeneration() || tenantId !== getStoredActiveTenantId() ||
        accountId !== queryClient.getQueryData<User | null>(['auth', 'user'])?.id) {
      throw new Error('Account or workspace changed. Reopen this booking.');
    }
  };
  const isCurrent = () => { try { assertCurrent(); return true; } catch { return false; } };
  const config: ApiRequestConfig = {
    assertRequestCurrent: assertCurrent,
    ...(accountId == null ? {} : { headers: { 'X-TARK-Expected-User-Id': String(accountId) }, recoverAccountChange: true }),
  };
  return { assertCurrent, isCurrent, config };
}
